export enum SubscriptionUpdateMethodsEnum {
  SUBSCRIPTION_UPDATE = 'subscription_update',
  NEXT_BILLING_PERIOD = 'next_billing_period',
}
